import React from 'react';
import Manage from './Manage';
import { useLocation } from 'react-router-dom';

const UsersUpdate = () => {
  const location = useLocation();
  const { itemState } = location.state;

  return (
      <div className={"p-lg-4 ps-4 pt-5 mx-auto w-80vw"}>
        <div className={"flex"}>
            <Manage item={itemState} />
        </div>
      </div>
    );
};

export default UsersUpdate;
